'use client';

import React from 'react';
import { usePathname } from 'next/navigation';
import { useVal } from '../../val/val.client';
import footerVal from '../../settings/footer.val';
import { BlankRectangle } from '../SVGs';
import Link from 'next/link';

const Footer = () => {
  const footerContent = useVal(footerVal);

  const pathname = usePathname();
  const isFrontPage = pathname === '/';
  const isProjectTalkPage = pathname === '/prosjektprat';

  if (isProjectTalkPage) {
    return null;
  }

  return (
    <div
      className={`px-16 pb-96 laptop:px-24 laptop:pb-64 mx-auto ${
        isFrontPage && 'max-xl-content'
      }`}
    >
      <div className="mb-64">
        <BlankRectangle color="var(--light)" />
      </div>
      <div className="flex justify-between flex-col tablet:flex-row gap-64 tablet:items-end">
        <div className="flex flex-col tablet:flex-row gap-64">
          {footerContent.contact.map((column, i) => {
            return (
              <div key={i} className="flex flex-col gap-8">
                {column.map((item, j) => {
                  return (
                    <FooterItem
                      key={j}
                      href={item.href || ''}
                      newTab={item.newTab}
                    >
                      {item.text}
                    </FooterItem>
                  );
                })}
              </div>
            );
          })}
        </div>

        <div className="flex flex-col tablet:flex-row gap-8 tablet:gap-64">
          {footerContent.links.map((item, i) => {
            return (
              <FooterItem key={i} href={item.href || ''} newTab={item.newTab}>
                {item.text}
              </FooterItem>
            );
          })}
        </div>
      </div>
    </div>
  );
};

interface FooterItemProps {
  children: React.ReactNode;
  href: string;
  newTab: boolean;
}

const FooterItem = ({ children, href, newTab }: FooterItemProps) => {
  const className = `flex flex-col content-start w-fit`;

  if (!href) {
    return <div className={className}>{children}</div>;
  }

  return (
    <div className={className}>
      <Link key={href} href={href}>
        <span className="inline-flex items-start gap-4">
          {children}

          {newTab && (
            <svg
              className="w-16 h-h16 inline-block shrink-0 pt-2"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M7 17L17 7M7 7h10v10"
              />
            </svg>
          )}
        </span>
      </Link>
    </div>
  );
};

export default Footer;
